import styled from "styled-components";

export const ModalBackground = styled.div`
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  color: white;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.95);
  width: 100vw;
  height: 100vh;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid lightgray;
  border-radius: 10px;
  padding: 0px 50px;

  .btn-close {
    border: 1px solid lightgray;
    color: red;
    font-size: 10px;
    margin: 10px 0 30px 0;

    :hover {
      background-color: red;
      color: white;
    }
  }

  > h3 {
    text-transform: uppercase;
    margin-bottom: 40px;
    color: lightgray;
  }

  > input {
    outline: none;
    border: none;
    padding: 10px;
    border-radius: 5px;
    background-color: lightgray;
  }

  .btn-add {
    color: white;
    border: 1px solid lightgray;
    margin: 30px 0 10px 0;

    :hover {
      background-color: lightgreen;
      color: black;
    }
  }
`;
